// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"afe03ece","240":"26a407ef","396":"922a0ca6"}[chunkId] + ".chunk.js";
};